import React, { useEffect, useState } from 'react';
import axios from 'axios';

const useMfeModule = (
  assetManifestUrl: string,
  fileName: string,
  moduleName: string
) => {
  const [mfeModule, setMfeModule] = useState<any>(null);
  useEffect(() => {
    let node: HTMLScriptElement | null = null;
    let intervalId: NodeJS.Timeout | null = null;
    axios.get(assetManifestUrl).then(assetManifest => {
      const mainFile = assetManifest.data[fileName];
      node = document.createElement('script');
      node.src = mainFile;
      node.async = true;
      document.body.appendChild(node);
      intervalId = setInterval(() => {
        const downloadedMfeModule = (window as any)[moduleName];
        if (downloadedMfeModule) {
          setMfeModule(downloadedMfeModule);
          if (intervalId !== null) {
            clearInterval(intervalId);
          }
        }
      }, 100);
    });
    return () => {
      if (node != null) {
        document.body.removeChild(node);
      }
      if (intervalId !== null) {
        clearInterval(intervalId);
      }
      setMfeModule(null);
    };
  }, []);
  return mfeModule;
};

export default useMfeModule;
